import { connect } from 'react-redux';
import React from 'react';
import { renderKBSelect, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { KBFormError,
KBButton } from
'components';
import { SEND_INVOICE_REPORT } from 'app/constants';

var SpaceSettingInvoiceReport = class extends React.Component {constructor(props) {super(props);this.updateSpace = this.updateSpace.bind(this);}updateSpace(

  model) {
    const { updateCurrentSpace } = this.props;

    updateCurrentSpace(
    {
      settings: JSON.stringify({
        subscription_settings: model }) },


    {
      key: 'subscription_settings' });


  }render()
  {
    const {
      fields: { need_send_invoice_daily_report },
      error,
      submitting,
      handleSubmit } =
    this.props;
    return (
      <form onSubmit={handleSubmit(this.updateSpace)}>
        <KBFormError err={this.props.error} />
        <div className="kb-form-container" style={{ padding: 0 }}>
          <KBFormError err={error} />
          <div className="kb-row">
            <Field name="need_send_invoice_daily_report" component={renderKBSelect}
            className="kb-form-group kb-form-c39 kb-form-alone"

            title="账单发送周期"
            arrayData={SEND_INVOICE_REPORT} />

          </div>
          <div className="kb-row m-top">
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              保存
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const setting = props.setting || {};
  const subscriptionSettings = setting.subscription_settings || {};
  let setting_value =
  subscriptionSettings.need_send_invoice_daily_report || 'weekly';

  return {
    initialValues: { need_send_invoice_daily_report: setting_value } };

}

const LEGACY_FORM_FIELDS = [
  "need_send_invoice_daily_report"
];

const formConfig = {
  form: 'SpaceSettingInvoiceReport',
  touchOnBlur: false };


export default connect(mapStateToProps)(reduxForm(formConfig)(withReduxFormFieldProps('SpaceSettingInvoiceReport', LEGACY_FORM_FIELDS)(SpaceSettingInvoiceReport)));
